import { makeStyles } from "@material-ui/core";

const CommonStyles = (theme) => ({
    rootTab: {
        backgroundColor: theme.palette.background.paper,
        width: 500,
    },
    root: {
        backgroundColor: 'white',
        border: '1px solid #6D6E6E',
        marginTop: '-10px'
    },
    rootTreeView: {
        height: 264,
        flexGrow: 1,
        maxWidth: '100vw',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    containerWithBorder: {
        backgroundColor: 'white',
        border: 'solid',
        borderWidth: 'thin'
    },
    containerWithBorderRound: {
        backgroundColor: 'white',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '5px',
    },
    cardHeader: {
        backgroundColor: '#7AA4D5',
        color: "white"
    },
    subHeaderPadding: {
        padding: 'px',
    },
    dashboardAlign: {
        textAlign: '-webkit-center'
    },
    alignCenter: {
        textAlign: '-webkit-center'
    },
    alignRight: {
        textAlign: '-webkit-right'
    },
    negativeSpacing: {
        padding: 30
    },
    dashboardIcon: {
        fontSize: '40px',
        color: '#79ba00'
    },
    searchAlign: {
        textAlign: 'right'
    },
    gridColorDefault: {
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '5px',
    },
    gridColor1: {
        backgroundColor: '  #7a9bc2 !important',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '5px',
        textAlign: '-webkit-center'
    },
    gridColor2: {
        backgroundColor: '#d8d8d8 !important',
        border: 'solid',
        borderWidth: 'thin',
        borderRadius: '5px',
    },
    textColorWhite: {
        color: 'white'
    },
    table: {
        headRow: {
            style: {
                border: 'none',
            },
        },
        headCells: {
            style: {
                color: '#202124',
                fontSize: '14px',
            },
        },
        rows: {
            highlightOnHoverStyle: {
                backgroundColor: 'rgb(230, 244, 244)',
                borderBottomColor: '#FFFFFF',
                borderRadius: '25px',
                outline: '1px solid #FFFFFF',
            },
        },
        pagination: {
            style: {
                border: 'none',
            },
        }
    }
})

export default CommonStyles

export const useTreeItemStyles = makeStyles((theme) => ({
    root: {
        color: theme.palette.text.secondary,
        '&:hover > $content': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:focus > $content, &$selected > $content': {
            backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
            color: 'var(--tree-view-color)',
        },
        '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
            backgroundColor: 'transparent',
        },
    },
    content: {
        color: theme.palette.text.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2),
        paddingRight: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '$expanded > &': {
            fontWeight: theme.typography.fontWeightRegular,
        },
    },
    group: {
        marginLeft: 0,
        '& $content': {
            paddingLeft: theme.spacing(2),
        },
    },
    expanded: {},
    selected: {},
    label: {
        fontWeight: 'inherit',
        color: 'inherit',
    },
    labelRoot: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0.5, 0),
    },
    labelIcon: {
        marginRight: theme.spacing(1),
    },
    labelText: {
        fontWeight: 'inherit',
        flexGrow: 1,
    },
}));

export const customStyleSecondary = {
    headCells: {
        style: {
            backgroundColor: "#7a9bc2",
            color: "white",
            fontWeight: '600',
            fontSize: "12px",
            paddingRight: '10px'
        },
        activeSortStyle: {
            color: "white",
            '&:focus': {
                outline: 'none',
            },
            '&:hover:not(:focus)': {
                color: "white",
            },
        },
        inactiveSortStyle: {
            '&:focus': {
                outline: 'none',
                color: "white",
            },
            '&:hover': {
                color: "white",
            },
        },
        title: {
            style: {
                fontSize: "24px",
                fontWeight: '600'
            }
        }
    },
    tableWrapper: {
        style: {
            border: '1px solid #7A9BC2'
        }
    }
}

export const customStylePrincipal = {
    headCells: {
        style: {
            backgroundColor: "white",
            color: "#7A9BC2",
            fontWeight: '600',
            fontSize: "12px",
            paddingRight: '10px',
            borderBottom: '1px solid #7A9BC2',
        },
        activeSortStyle: {
            color: "#7A9BC2",
            '&:focus': {
                outline: 'none',
            }
        }
    },
    subHeader: {
        style: {
            backgroundColor: "#7A9BC2",
            borderColor: '#7A9BC2',
            width:'1345.84px !important'
        }
    },
    tableWrapper: {
        style: {
            border: '1px solid #7A9BC2'
        }
    }
}

export const customStylePrincipalAP = {
    headCells: {
        style: {
            backgroundColor: "white",
            color: "#7A9BC2",
            fontWeight: '600',
            fontSize: "12px",
            paddingRight: '10px',
            borderBottom: '1px solid #7A9BC2',
        },
        activeSortStyle: {
            color: "#7A9BC2",
            '&:focus': {
                outline: 'none',
            }
        }
    },
    subHeader: {
        style: {
            backgroundColor: "#7A9BC2",
            borderColor: '#7A9BC2',
            width:'1345.84px !important'
        }
    },
    tableWrapper: {
        style: {
            border: '1px solid #7A9BC2'
        }
    },
    header: {
        style: {
            backgroundColor: "white",
            borderColor: 'white',
            marginTop: '-0.5em',
            marginBottom: '-0.5em',
            marginLeft: '-0.5em',
            color: 'red',
            fontSize: '17px',
        }
    }
}